export async function limparDadosRelatorioTabelaPrecoAdesao (dados = []) {
    return dados.map(adesaoItem =>        
        [adesaoItem.subgrupo.trim(),adesaoItem.CidadesIBGE.NOME,adesaoItem.UF,adesaoItem.carencia,adesaoItem.adesao_novo,adesaoItem.percentualDesconto,adesaoItem.adesao_troca,adesaoItem.adesao_reab]
    );
}